import { MainPageLayout } from "components/MainPageLayout";
import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";

interface Props extends ThemeProps {
  $hasSideMenu?: boolean;
}

export const StyledMainPageLayout = styled(MainPageLayout)<Props>`
  gap: 0;

  > main {
    width: 100%;
    padding: 0;
    max-width: unset;
  }
`;

export const StyledWelcomeBox = styled.section<Props>`
  padding: 5rem 4rem;
  display: flex;
  align-items: center;
  column-gap: 3rem;

  background-color: ${(props: Props) => props.theme.palette.mint._500};
  background-image: unset;
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const StyledMessage = styled.article<ThemeProps>`
  color: ${(props: ThemeProps) => props.theme.palette.neutral.black};

  p {
    font-size: ${(props: ThemeProps) => props.theme.font.size._18};
    line-height: 180%;
    white-space: pre-line;
  }

  h1 {
    font-size: 4rem;
    line-height: 125%;
    word-break: normal;
  }
`;

export const StyledPreparationBox = styled.section<Props>`
  display: flex;
  column-gap: 5rem;
  align-items: flex-start;
  margin: 4.75rem 2rem;
`;

export const StyledCollage = styled.img<ThemeProps>`
  max-width: 50%;
`;

export const StyledTipContainer = styled.section<ThemeProps>`
  > h3 {
    margin-top: 2rem;
    font-size: ${(props: ThemeProps) => props.theme.font.size._18};
  }
`;
